import React, { useCallback } from 'react';
import map from 'lodash/map';

import { useTranslation } from '@lyearn/i18n';
import AsyncSelect from '@/components/AsyncSelect';
import { renderUserTag } from '@/components/AsyncSelect/entity/user/renderers';
import useUsers from '@/components/UsersSearch/hooks/useUsers';
import { UserFragment } from '@/graphql/fragments/generated/User';
import { renderAddUsersOption } from '@/modules/report/views/ReportEditor/components/ReportExportModal/components/AddReportRecipients/renderers';

import { AddReportRecipientsProps } from './types';
import { getOptionLabel, isOptionEqualToValue } from './utils';

function AddParticipants(props: AddReportRecipientsProps) {
  const { t } = useTranslation();
  const { error, value, onChange: onChangeProp } = props;

  const onChange = useCallback(
    (nextValue: UserFragment[]) => {
      onChangeProp(map(nextValue, (user) => user.id));
    },
    [onChangeProp],
  );

  const { data: selectedUsers } = useUsers({ ids: value, pause: value.length === 0 });

  return (
    <AsyncSelect<UserFragment, { searchText: string }, true, true, false>
      disableClearable
      multiple
      disableCloseOnSelect={false}
      error={error}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      placeholder={value.length ? '' : t('Meeting:AddParticipants')}
      popupIcon={null}
      renderOption={renderAddUsersOption}
      tagLabelRenderer={renderUserTag}
      useOptionsQuery={useUsers}
      value={value.length === 0 ? [] : selectedUsers}
      onChange={onChange}
    />
  );
}

export default React.memo(AddParticipants);
